import React from 'react';
import closeIcon from '../../img/sprite/key-chip-close.svg';

const WHITE_KEYS = ['B', 'A', 'G', 'F', 'E', 'D', 'C'];

const BLACK_KEYS = [
	{note: 'A#', afterIndex: 0},
	{note: 'G#', afterIndex: 1},
	{note: 'F#', afterIndex: 2},
	{note: 'D#', afterIndex: 4},
	{note: 'C#', afterIndex: 5},
];

const NOTE_ALIASES = {
	C: ['C'],
	'C#': ['C#', 'C♯', 'Db', 'D♭'],
	D: ['D'],
	'D#': ['D#', 'D♯', 'Eb', 'E♭'],
	E: ['E'],
	F: ['F'],
	'F#': ['F#', 'F♯', 'Gb', 'G♭'],
	G: ['G'],
	'G#': ['G#', 'G♯', 'Ab', 'A♭'],
	A: ['A'],
	'A#': ['A#', 'A♯', 'Bb', 'B♭'],
	B: ['B'],
};

const matchesNote = (choice, note) => {
	const value = String(choice).trim();
	return NOTE_ALIASES[note].some((alias) => (
		value === alias
		|| value.startsWith(`${alias} `)
		|| value.startsWith(`${alias}/`)
		|| value.startsWith(`${alias}-`)
	));
};

export const getKeyChoiceValue = (note, choices = []) => {
	const match = choices.find((choice) => matchesNote(choice, note));
	return match || note;
};

export const getKeyNoteLabel = (choice, choices = []) => {
	const notes = Object.keys(NOTE_ALIASES);
	const found = notes.find((note) => matchesNote(choice, note));
	if (found) {
		return found;
	}
	const fromChoices = notes.find((note) => getKeyChoiceValue(note, choices) === choice);
	return fromChoices || choice;
};

const CatalogKeyPiano = ({choices = [], selected = [], onToggle, onRemove}) => {
	const selectedSet = new Set(selected);

	const isNoteSelected = (note) => {
		const value = getKeyChoiceValue(note, choices);
		return selectedSet.has(value) || selectedSet.has(note);
	};

	const handleNote = (note) => {
		onToggle(getKeyChoiceValue(note, choices));
	};

	return (
		<div className="catalog__filter-key">
			<div className="catalog__filter-piano" role="group" aria-label="Тональность">
				<div className="catalog__filter-piano-whites">
					{WHITE_KEYS.map((note) => (
						<button
							key={note}
							type="button"
							className={`catalog__filter-piano-white${isNoteSelected(note) ? ' is-selected' : ''}`}
							aria-pressed={isNoteSelected(note)}
							onClick={() => handleNote(note)}
						>
							{note}
						</button>
					))}
				</div>
				{BLACK_KEYS.map(({note, afterIndex}) => (
					<button
						key={note}
						type="button"
						className={`catalog__filter-piano-black${isNoteSelected(note) ? ' is-selected' : ''}`}
						style={{top: `calc(${((afterIndex + 1) / WHITE_KEYS.length) * 100}% - 23px)`}}
						aria-pressed={isNoteSelected(note)}
						onClick={() => handleNote(note)}
					>
						{note}
					</button>
				))}
			</div>
			<div className="catalog__filter-piano-chips">
				{selected.map((choice) => {
					const label = getKeyNoteLabel(choice, choices);
					return (
						<button
							key={choice}
							type="button"
							className="catalog__filter-piano-chip"
							onClick={() => onRemove(choice)}
						>
							<span>{label}</span>
							<img src={closeIcon} alt="" width="12" height="12"/>
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default CatalogKeyPiano;
